import React, {
  useMemo,
  useState,
  useCallback,
} from 'react'

import {
  Button,
} from '@usap/uicomponents'

import { usePopUpContext } from '../../../../../providers/PopUpProvider'
import useRemoveItemsCallback from '../../../../../hooks/actions/useRemoveItemsCallback'
import useProceedToCheckout from '../../../../Summary/ProceedToCheckout/Regular/hooks/useProceedToCheckout'
import useContinueShopping from '../../../../Summary/ProceedToCheckout/Regular/hooks/useContinueShopping'
import useWmoEnabled from '../../../../../../../hooks/useWmoEnabled'
import ButtonWmo from '../../../../../../Wmo/ButtonWmo/ButtonWmo'

const RemoveAndProceedToCheckout = params => {
  const { data } = params
  const [isProcessing, setIsProcessing] = useState(false)
  const [proceed, shouldProceed] = useState(false)

  const {
    shouldShowOosProducts,
  } = usePopUpContext()

  const isWmoEnabled = useWmoEnabled()

  const buttonLabel = useMemo(
    () => {
      if (proceed) return 'Proceeding to Checkout...'
      if (isProcessing) return 'Removing item(s)...'
      return isWmoEnabled ? 'Remove Item(s) and Checkout' : 'Remove item(s) and proceed to checkout'
    },
    [isProcessing, proceed, isWmoEnabled],
  )

  const removeItems = useRemoveItemsCallback()
  const handleProceedToCheckout = useProceedToCheckout()

  const handleContinueShopping = useContinueShopping()

  const handleAction = useCallback(
    async () => {
      setIsProcessing(true)
      const items = [...data]

      const resRemainingItems = await removeItems(items)
      if (
        resRemainingItems &&
        (
          !resRemainingItems.items ||
          (resRemainingItems.items && resRemainingItems.items.length < 1)
        )
      ) {
        await handleContinueShopping(data)
      } else {
        shouldProceed(true)
        await handleProceedToCheckout(resRemainingItems)
      }
      setIsProcessing(false)
      shouldShowOosProducts(false)
    },
    [
      setIsProcessing,
      data,
      removeItems,
      shouldShowOosProducts,
      handleProceedToCheckout,
      shouldProceed,
      handleContinueShopping,
    ],
  )

  if (isWmoEnabled) {
    return (
      <ButtonWmo
        filled
        disabled={isProcessing}
        label={buttonLabel}
        onClick={handleAction}
      />
    )
  }

  return (
    <Button
      custom
      hideBorder={false}
      disabled={isProcessing}
      label={buttonLabel}
      onClick={handleAction}
    />
  )
}

export default RemoveAndProceedToCheckout
